import { render, staticRenderFns } from "./trail.vue?vue&type=template&id=48158dc4&scoped=true&"
import script from "./trail.vue?vue&type=script&lang=js&"
export * from "./trail.vue?vue&type=script&lang=js&"
import style0 from "./trail.vue?vue&type=style&index=0&id=48158dc4&scoped=true&lang=css&"
import style1 from "./trail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48158dc4",
  null
  
)

export default component.exports